import { useLoginContext } from "../../../App";
import { useContentContext } from "../../layout/Layout";
import { showNotification } from "../../b2b-common/Notification";
import { fetchPlanStatusTrendProgressData } from "../../../services/b2b-plans-apiService";
import { useQuery } from '@tanstack/react-query';
import { useEffect } from "react";
import useB2BTranslation from "../../b2b-common/hooks/useB2BTranslation";

const usePlanStatusTrendProgressData = (planUUID) => {
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();
    const { t } = useB2BTranslation('b2b-plans');

    const { accessToken } = loginData;

    const fetchPlanStatusTrendProgress = async () => {
        const response = await fetchPlanStatusTrendProgressData(accessToken, planUUID);
        return response;
    };

    const { data: planStatusTrendProgressData, error } = useQuery({
        queryKey: ['planStatusTrendProgressData', planUUID],
        queryFn: fetchPlanStatusTrendProgress,
        enabled: !!planUUID,
    });

    useEffect(() => {
        if (error) {
            console.error('Error fetching plan status, trend and progress data:', error);
            showNotification(setNotification, t('Error fetching plan status, trend and progress data: ') + error.message, 'error', 5000);
        }
    }, [error]);

    return { planStatusTrendProgressData };
}

export default usePlanStatusTrendProgressData;